import HTMLMediaElement from '../html-media-element/HTMLMediaElement.js';

/**
 * HTML Video Element.
 *
 * Reference:
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement.
 *
 */
export default class HTMLVideoElement extends HTMLMediaElement {}
